<template>
    <div>
        <p v-for="error in formErrors?.errors?.choosen_general_options || []" :key="error" class="text-danger">{{ error }}</p>
        <div class="one-menu mb-2" v-for="option in available_general_options" :key="option.id">
            <div class="row text-start align-items-center">
                <div class="col-sm-8">
                    <label :for="`booking-extra-${option.id}`" class="form-label mb-1"
                        >{{ option.name }}{{ option.price ? ` · ${formatCurrency(option.price, getRestaurantCurrency(restaurantId))}` : "" }}</label
                    >
                    <small class="d-block text-muted">{{ option.description }}</small>
                </div>
                <div class="col-sm-4">
                    <input
                        v-if="option.quantity_type === 'unlimited'"
                        :id="`booking-extra-${option.id}`"
                        type="number"
                        min="0"
                        step="1"
                        class="form-control"
                        :value="quantity(option)"
                        @input="choose(option, $event.target.value)" />
                    <select
                        v-else
                        :id="`booking-extra-${option.id}`"
                        class="form-select"
                        :value="quantity(option)"
                        @change="choose(option, $event.target.value)">
                        <option :value="0">0</option>
                        <option v-if="option.quantity_type === 'mandatory_for_each'" :value="nb_total">{{ nb_total }}</option>
                        <template v-else
                            ><option v-for="count in Math.max(0, Number(nb_total) || 0)" :key="count" :value="count">{{ count }}</option></template
                        >
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        available_general_options: { type: Array, required: true },
        reservation: { type: Object, required: true },
        nb_total: { default: 0 },
        formErrors: { default: null },
        restaurantId: { type: Number, required: true },
    },
    methods: {
        quantity(option) {
            return Number(this.reservation.choosen_general_options["id_" + option.id]?.value || 0);
        },
        choose(option, value) {
            value = Math.max(0, parseInt(value, 10) || 0);
            if (option.quantity_type === "limited_by_pers") value = Math.min(value, this.nb_total);
            if (option.quantity_type === "mandatory_for_each" && value > 0) value = this.nb_total;
            if (value > 0) this.reservation.choosen_general_options["id_" + option.id] = { id: option.id, value, price: option.price };
            else delete this.reservation.choosen_general_options["id_" + option.id];
        },
    },
    watch: {
        nb_total() {
            this.available_general_options.forEach((option) => this.choose(option, this.quantity(option)));
        },
    },
    created() {
        this.available_general_options.forEach((option) => {
            const current = this.reservation.choosen_general_options["id_" + option.id];
            const previous = this.reservation.back_choosen_general_options?.find((item) => item.id === option.id);
            this.choose(option, current?.value ?? previous?.nb ?? 0);
        });
    },
};
</script>
